import { render, staticRenderFns } from "./CategoryTabs.vue?vue&type=template&id=bc115422&scoped=true&"
import script from "./CategoryTabs.vue?vue&type=script&lang=js&"
export * from "./CategoryTabs.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTabs.vue?vue&type=style&index=0&id=bc115422&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc115422",
  null
  
)

export default component.exports